const app_config = {
  "environment": "production",
  "su_api_host": "api.checkyourlink.com",
  "client_version": "v1.8.0",
};

export default app_config;
